<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>出库列表</b></p>

            <div style="display:inline-block">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">待接收</el-radio-button>
                    <el-radio-button label="1">待审批</el-radio-button>
                    <el-radio-button label="2">已出库</el-radio-button>
                    <el-radio-button label="3">已退回</el-radio-button>
                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入产品/客户" v-model="queryValue" class="input-with-select">

                    <el-button slot="append" icon="el-icon-search" @click="searchOut"></el-button>
                </el-input>
            </div>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="backClick()">退回</el-button>
            </p>
            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="operateClick(2)">审批</el-button>
                <span>-</span>
            </p>
            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="operateClick(1)">接收</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="openDrawer">新增出库</el-button>
                <span>-</span>
            </p>

        </div>

        <div style="margin-bottom: 20px;">
            <el-date-picker v-model="timeFrameValue" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="monthChange">
            </el-date-picker>

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:0;">
                <el-button round @click="exportExcel">导出</el-button>
            </p> -->
        </div>

        <el-table :data="outStockList" style="width: 100%" @select="selectClick" @row-click="rowClick"
            ref="outStockTable" highlight-current-row v-loading="loading">
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="outStockCode" label="出库编号" min-width="15%">
            </el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="30%">
            </el-table-column>

            <el-table-column prop="customer" label="客户" min-width="10%">
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="8%">
            </el-table-column>

            <el-table-column prop="createdTime" label="申请日期" min-width="10%">
            </el-table-column>
            <el-table-column prop="applicant" label="申请人" min-width="8%">
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="20%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        查看
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small"
                        v-if="scope.row.status == '已出库' ? false : true">
                        删除
                    </el-button>

                    <el-button @click="tmplClick(scope.row)" type="primary" round size="small"
                        v-if="scope.row.status == '已出库' ? true : false">
                        打单
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes,prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-drawer title="出库详情" :visible.sync="drawerVisible" size="70%" style="text-align: left;">

            <!-- <div style="padding: 0 10px;"> -->
            <el-row>
                <el-col :span="8">

                    <p style="display:inline-block;width:80px;text-align: center;">申请日期</p>
                    <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期"
                        :disabled="productItemDisabled">
                    </el-date-picker>
                </el-col>

                <el-col :span="8">
                    <p style="display:inline-block;width:80px;text-align: center;">备注</p>
                    <el-input placeholder="请输入" v-model="form.remark" clearable style="display:inline-block;width:350px"
                        :disabled="productItemDisabled"></el-input>

                </el-col>

                <el-col :span="8">
                    <p style="display:inline-block;width:80px;text-align: center;">客户</p>
                    <el-select v-model="form.customerAbbrev" filterable remote reserve-keyword placeholder="请输入关键字"
                        :remote-method="searchCustomer" :loading="loading" @change="cusChange" style="width:220px"
                        :disabled="productItemDisabled">
                        <el-option v-for="item in form.customerList" :key="item.value" :label="item.customerAbbrev"
                            :value="item.customerId">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="8">
                    <p style="display:inline-block;width:80px;text-align: center;" v-if="saveBtnShow">大类</p>
                    <el-select v-model="form.bigType" placeholder="请选择" style="width:220px" @change="bigChange"
                        v-if="saveBtnShow">
                        <el-option v-for="item in form.bigTypeList" :key="item.value" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>

                </el-col>
                <el-col :span="8">
                    <p style="display:inline-block;width:80px;text-align: center;" v-if="saveBtnShow">类别</p>
                    <el-select v-model="form.productType" placeholder="请选择" style="width:220px" @change="typeChange"
                        v-if="saveBtnShow">
                        <el-option v-for="item in form.prodTypeList" :key="item.value" :label="item.productTypeName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>

                <el-col :span="8">
                    <p style="display:inline-block;width:80px;text-align: center;" v-if="saveBtnShow">添加产品</p>
                    <el-select v-model="form.productName" filterable remote reserve-keyword placeholder="请输入关键字"
                        :remote-method="searchProduct" :loading="loading" v-if="saveBtnShow">
                        <el-option v-for="item in form.productList" :key="item.value" :label="item.productName"
                            :value="item.productId">
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click="addProduct" v-if="saveBtnShow">添加</el-button>

                </el-col>
            </el-row>
            <!-- </div> -->

            <div style="padding:10px;margin-bottom: 20px;">
                <el-table :data="outStockProdList" show-summary>
                    <el-table-column prop="productCode" label="产品编号" min-width="20%">
                    </el-table-column>
                    <el-table-column prop="productName" label="产品名称" min-width="30%">
                    </el-table-column>
                    <el-table-column prop="productWeight" label="产品重量" min-width="10%">
                    </el-table-column>

                    <el-table-column prop="quantity" label="数量" min-width="10%">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.quantity" size="mini" :disabled="productItemDisabled" @blur="quantityBlur(scope.row)">
                            </el-input>
                        </template>
                    </el-table-column>

                    <el-table-column prop="unit" label="单位" min-width="10%">
                    </el-table-column>

                    <el-table-column prop="unitPrice" label="单价" min-width="10%">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.unitPrice" size="mini" :disabled="productItemDisabled"
                                @input="priceBlur(scope.row)"></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column prop="amount" label="金额" min-width="15%">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.amount" size="mini" disabled></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column prop="productRemark" label="备注" min-width="25%">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.productRemark" size="mini"
                                :disabled="productItemDisabled"></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">

                            <el-button @click="removeProduct(scope.row)" type="danger" round size="small"
                                :disabled="delBtnDisable">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div>
                <div style="margin-left: 40%;">
                    <el-button type="primary" round @click="addOutStock" v-if="saveBtnShow">保存</el-button>

                    <el-button type="primary" round @click="editClick" v-if="!saveBtnShow && editBtnShow">编辑</el-button>

                    <!-- <el-button round @click="printInStock(1)" v-if="!saveBtnShow">打印</el-button> -->
                </div>

            </div>

            <div>
                <p style="margin-left:20px;font-weight:bold">流转日志</p>
                <div style="padding:10px;">
                    <el-table :data="logList">
                        <el-table-column prop="createdTime" label="操作时间" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="operationType" label="操作类型" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="operator" label="操作人" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="remark" label="操作说明" min-width="25%">
                        </el-table-column>
                    </el-table>
                </div>

            </div>

        </el-drawer>

        <el-dialog title="退回" :visible.sync="dialogVisible" v-dialogDrag v-if="dialogVisible">
            <p style="display:inline-block;width:80px;text-align: center;">退回原因：</p>
            <el-input placeholder="请输入" v-model="backRemark" clearable
                style="display:inline-block;width:400px"></el-input>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmBack">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="选择模版" :visible.sync="tmplDlgVisible">
            <p style="display:inline-block;width:80px;text-align: center;">模版：</p>
            <el-select v-model="currentTmpl" placeholder="请选择模版" style="width:220px" @change="tmplChange">
                <el-option v-for="item in printTmplList" :key="item.id" :label="item.tmplName" :value="item.id">
                </el-option>
            </el-select>

            <div slot="footer" class="dialog-footer">
                <el-button @click="tmplDlgVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmTmpl">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="打印送货单" :visible.sync="printDlgVisible" width="60%">
            <div id="delivery-note" v-html="noteContent"></div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="printDlgVisible = false">取 消</el-button>
                <el-button type="primary" @click="printNote(2)">打 印</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "OutStock",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),
            userName: this.getUserName(),

            outStockList: [],

            drawerVisible: false,
            dialogVisible: false,

            tmplDlgVisible: false,
            queryValue: '',

            statusSearch: 0,
            form: {
                id: '',
                outStockCode: '自动生成',

                customerList: [],
                customerId: '',
                customerAbbrev: '',

                bigType: '',
                bigTypeList: [{
                    id: 0,
                    name: '零件'
                }, {
                    id: 1,
                    name: '半成品'
                }, {
                    id: 2,
                    name: '成品'
                }],
                productType: '',
                prodTypeList: [],
                productList: [],
                productId: '',
                productName: '',

                createdTime: new Date(),
                status: 0,
                remark: '',
            },
            loading: false,
            formLabelWidth: '120px',

            timeFrameValue: '',
            startTime: null,
            endTime: null,

            outStockProdList: [],
            productItemDisabled: false,
            delBtnDisable: false,
            logList: [],

            saveBtnShow: true,
            editBtnShow: false,

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0,

            backRemark: '',

            printDlgVisible: false,

            currentTmpl: '',
            printTmplList: [],
            tmplFileName: '',

            companyName: '',
            companyAddress: '',
            companyLogo: '',
            serialNumPre: '',
            companyRemark: '',

            deliveryNum: '',

            cusFullName: '',
            cusAddress: '',
            cusContacts: '',
            cusTelephone: '',

            rules: {
                customer: [
                    { required: true, message: '请输入客户', trigger: 'blur' },
                    { required: true, message: '请输入客户', trigger: 'change' }
                ],
                salesman: [
                    { required: true, message: '请输入业务员', trigger: 'blur' },
                    { required: true, message: '请输入业务员', trigger: 'change' }
                ],
                productName: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { required: true, message: '请输入产品名称', trigger: 'change' }
                ],
                createdTime: [
                    { required: true, message: '请选择下单日期', trigger: 'blur' },
                    { required: true, message: '请选择下单日期', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        typeChange() {

            this.getAllStockProduct()

            this.form.productName = ''
        },
        bigChange() {
            this.getTypeByBigType()

            this.form.productType = ''
            this.form.productName = ''
        },
        getTypeByBigType() {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/type/getAll",
                data: {
                    bigType: this.form.bigType,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.form.prodTypeList = data.data

            })
        },
        monthChange() {
            this.startTime = this.timeFrameValue[0]
            this.endTime = this.timeFrameValue[1]

            this.getAll(this.statusSearch)
        },
        quantityBlur(row) {
            // console.log('quantityBlur')
            // console.log(row)
            if (row.quantity > row.stockQuantity) {
                this.$message('当前产品的库存只有 ' + row.stockQuantity)
                row.quantity = 1
            }
        },
        priceBlur(row) {
            // console.log('priceBlur')
            // console.log(row)
            row.amount = row.quantity * row.unitPrice
        },
        addProduct() {

            // console.log('add')
            // console.log(this.form.productName)

            const index = this.form.productList.findIndex(obj => obj.productId == this.form.productName)

            // console.log(this.form.productList[index])

            this.outStockProdList.push(this.form.productList[index])
        },
        removeProduct(row) {

            // console.log('remove')
            // console.log(row)

            const index = this.outStockProdList.findIndex(obj => obj.productId == row.productId)

            this.outStockProdList.splice(index, 1)
        },
        getBaseCustomerAll(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/customer/getAll",
                data: {
                    queryParam: val,

                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.customerList = data.data
            })
        },
        searchCustomer(val) {
            if (val !== '') {
                this.loading = true

                setTimeout(() => {
                    this.loading = false;
                    this.getBaseCustomerAll(val)
                }, 200)

            }
        },
        cusChange(value) {
            this.form.customerId = value
        },
        getAllStockProduct(val) {
            this.$axios({
                method: "post",
                url: "/shiro/product/stock/getAll",
                data: {
                    companyId: this.companyId,
                    bigType: -1,
                    productType: this.form.productType,
                    pageIndex: -1,
                    pageNum: -1
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.productList = data.data

            })
        },
        searchProduct(val) {
            if (val !== '') {
                this.loading = true
                setTimeout(() => {
                    this.loading = false

                    this.getAllStockProduct(val)
                }, 200)

            } else {
                this.form.productList = []
            }
        },
        selectClick(selection, row) {

            this.$refs.outStockTable.clearSelection()
            this.$refs.outStockTable.toggleRowSelection(row)
            this.form.id = row.id
            this.form.status = row.status
        },
        rowClick(row) {
            //console.log(row)
            this.$refs.outStockTable.clearSelection()
            this.$refs.outStockTable.toggleRowSelection(row)
            this.form.id = row.id
            this.form.status = row.status
        },
        searchOut(query) {
            this.outStockList = []

            if (this.queryValue !== '') {
                this.loading = true
                setTimeout(() => {
                    this.loading = false

                    this.getAll(this.statusSearch)
                }, 200)
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        getOutStockProduct(row) {

            this.$axios({
                method: "post",
                url: "/shiro/out/stock/getOne",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.outStockProdList = data.data.outStockProductVOList

                for (let i in this.outStockProdList) {
                    this.outStockProdList[i].productRemark = this.outStockProdList[i].remark
                }

                this.logList = data.data.inOutLogsList
                for (let i in this.logList) {
                    this.logList[i].createdTime = this.$moment(this.logList[i].createdTime).format("YYYY-MM-DD HH:mm:ss")

                    if (this.logList[i].operationType == 0) {
                        this.logList[i].operationType = '申请'
                    } else if (this.logList[i].operationType == 1) {
                        this.logList[i].operationType = ' 接收'
                    } else if (this.logList[i].operationType == 2) {
                        this.logList[i].operationType = ' 审批'
                    } else {
                        this.logList[i].operationType = '退回'
                    }
                }

            })
        },
        handleClick(row) {
            // console.log(row);
            this.form.id = row.id

            this.form.outStockCode = row.outStockCode

            this.form.createdTime = row.createdTime

            this.form.status = null
            this.form.remark = row.remark

            this.form.customerAbbrev = row.customer

            this.form.productName = ''

            this.drawerVisible = true
            this.productItemDisabled = true
            this.delBtnDisable = true

            this.saveBtnShow = false
            this.editBtnShow = false
            if (row.status == '待接收') {
                this.editBtnShow = true
            }

            this.getOutStockProduct(row)

            this.getAllStockProduct('')
        },
        openDrawer() {

            this.form.id = ''
            this.form.outStockCode = '自动生成'

            this.form.applicant = ''

            this.form.customerAbbrev = ''
            this.form.productName = ''

            // this.form.createdTime = new Date()

            this.form.status = 0
            this.form.remark = ''

            this.outStockProdList = []
            this.logList = []

            this.saveBtnShow = true
            this.productItemDisabled = false
            this.drawerVisible = true

            this.getAllStockProduct('')

        },
        operateClick(val) {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请选择入库单'
                })
                return
            }

            this.$confirm('确定执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                if (val == 1) {
                    this.receiveClick()
                } else {
                    this.checkClick()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        receiveClick() {

            this.$axios({
                method: "post",
                url: "/shiro/out/stock/receive",
                data: {
                    id: this.form.id,
                    status: 1,
                    applicant: this.userId,
                    remark: '',
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false
                this.getAll(this.statusSearch)
            })
        },
        checkClick() {

            this.$axios({
                method: "post",
                url: "/shiro/out/stock/check",
                data: {
                    id: this.form.id,
                    status: 2,
                    applicant: this.userId,
                    remark: '',
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false
                this.getAll(this.statusSearch)
            })
        },
        backClick() {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请选择出库单'
                })
                return
            }

            if (this.form.status == '已出库' || this.form.status == '已退回') {
                this.$message({
                    type: 'info',
                    message: '当前状态不允许操作'
                })
                return
            }

            this.dialogVisible = true
        },
        confirmBack() {

            this.$axios({
                method: "post",
                url: "/shiro/out/stock/goBack",
                data: {
                    id: this.form.id,
                    status: 3,
                    applicant: this.userId,
                    remark: this.backRemark,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.dialogVisible = false
                this.getAll(this.statusSearch)
            })
        },
        //用户选择了模版
        tmplChange() {
            this.$axios({
                method: "post",
                url: "/shiro/print/set/getOne",
                data: {
                    id: this.currentTmpl,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data.data

                //根据选择的模板，获取设置的公司相关信息
                this.companyLogo = data.companyLogo

                this.companyName = data.companyName

                this.companyAddress = data.companyAddress
                this.serialNumPre = data.serialNumPre
                this.companyRemark = data.remark

                this.getTmplFile(data.printTmplId)

            })
        },
        //获取用户选择的模板所对应的文件名
        getTmplFile(val) {
            this.$axios({
                method: "post",
                url: "/shiro/print/tmpl/getOne",
                data: {
                    id: val,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data.data

                this.tmplFileName = data.fileName
                // console.log(this.tmplFileName)

                this.getCusInfo()
            })
        },
        //获取客户相关信息
        getCusInfo() {
            this.$axios({
                method: "post",
                url: "/shiro/base/customer/getOne",
                data: {
                    customerId: this.form.customerId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data.data

                this.cusFullName = data.customerFullName

                this.cusAddress = data.warehouseAddress
                this.cusContacts = data.warehouseContacts
                this.cusTelephone = data.warehousePhone

                this.tmplDlgVisible = false
                this.printClick()
            })
        },
        confirmTmpl() {

        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeOutStock(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        //打开选择模版对话框
        tmplClick(row) {
            //获取出库产品明细
            this.getOutStockProduct(row)

            this.currentTmpl = ''
            this.form.customerId = row.customerId
            this.deliveryNum = row.outStockCode
            this.form.applicant = row.applicant

            //获取当前企业所有的打印模版
            this.$axios({
                method: "post",
                url: "/shiro/print/set/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.printTmplList = data.data

                this.tmplDlgVisible = true
            })

        },
        printClick(row) {
            var compLogo = this.companyLogo
            var compName = this.companyName
            var compAddress = this.companyAddress

            var noteRemark = this.companyRemark

            var cusName = this.cusFullName
            var cusAddress = this.cusAddress
            var cusContacts = this.cusContacts
            var cusTelephone = this.cusTelephone

            var deliveryDate = this.$moment(new Date()).format("YYYY-MM-DD")
            // console.log('username')
            // console.log(this.userName)
            var noteMaker = this.userName

            this.$axios.get(this.tmplFileName).then(response => {
                // console.log('response')
                // console.log(response)

                this.noteContent = response.data.replace("{{logoUrl}}", compLogo)

                this.noteContent = this.noteContent.replace("{{ compName }}", compName)
                this.noteContent = this.noteContent.replace("{{ compAddress }}", compAddress)

                this.deliveryNum = this.deliveryNum.replace("ck", this.serialNumPre)

                this.noteContent = this.noteContent.replace("{{noteRemark}}", noteRemark)

                this.noteContent = this.noteContent.replace("{{deliveryNum}}", this.deliveryNum)

                this.noteContent = this.noteContent.replace("{{cusName}}", cusName)
                this.noteContent = this.noteContent.replace("{{cusAddress}}", cusAddress)
                this.noteContent = this.noteContent.replace("{{cusContacts}}", cusContacts)
                this.noteContent = this.noteContent.replace("{{cusTelephone}}", cusTelephone)

                this.noteContent = this.noteContent.replace("{{deliveryDate}}", deliveryDate)
                this.noteContent = this.noteContent.replace("{{noteMaker}}", noteMaker)

                this.noteContent = this.noteContent.replace("{{applicant}}", this.form.applicant)

                // let noteArr = [{
                //     productName: '300w萤火虫',
                //     quantity: 2500,
                // }]

                let noteArr = this.outStockProdList

                // this.noteContent = this.noteContent.replace("noteList", noteArr)
                var count = noteArr.length

                var total = 0, totalAmount = 0

                for (var i in noteArr) {
                    // console.log('for')
                    // console.log(noteArr[i])
                    // console.log(i)

                    total = total + noteArr[i].quantity
                    totalAmount = totalAmount + noteArr[i].amount

                    var index = parseInt(i) + 1

                    var NoIndex = "{{No" + index + "}}"
                    // console.log(NoIndex)

                    this.noteContent = this.noteContent.replace("{{No" + index + "}}", i + 1)
                    this.noteContent = this.noteContent.replace("{{productName" + index + "}}", noteArr[i].productName)

                    this.noteContent = this.noteContent.replace("{{unit" + index + "}}", "PCS")

                    this.noteContent = this.noteContent.replace("{{quantity" + index + "}}", noteArr[i].quantity)

                    this.noteContent = this.noteContent.replace("{{price" + index + "}}", noteArr[i].unitPrice.toFixed(2))
                    this.noteContent = this.noteContent.replace("{{amount" + index + "}}", noteArr[i].amount.toFixed(2))
                    this.noteContent = this.noteContent.replace("{{remark" + index + "}}", noteArr[i].remark)
                }

                for (var j = count; j < 9; j++) {
                    this.noteContent = this.noteContent.replace("{{No" + (j + 1) + "}}", "")
                    this.noteContent = this.noteContent.replace("{{productName" + (j + 1) + "}}", "")

                    this.noteContent = this.noteContent.replace("{{unit" + (j + 1) + "}}", "")
                    this.noteContent = this.noteContent.replace("{{quantity" + (j + 1) + "}}", "")
                    this.noteContent = this.noteContent.replace("{{price" + (j + 1) + "}}", "")
                    this.noteContent = this.noteContent.replace("{{amount" + (j + 1) + "}}", "")
                    this.noteContent = this.noteContent.replace("{{remark" + (j + 1) + "}}", "")
                }

                var totAmountUpper = this.digitUppercase(totalAmount.toFixed(2))
                // console.log(totAmountUpper)
                this.noteContent = this.noteContent.replace("{{totAmountUpper}}", totAmountUpper)
                this.noteContent = this.noteContent.replace("{{total}}", total)
                this.noteContent = this.noteContent.replace("{{totalAmount}}", totalAmount.toFixed(2))

                // console.log(this.noteContent)

                this.printDlgVisible = true
            })

        },
        printNote(fang) {
            var content = document.getElementById("delivery-note").innerHTML
            // console.log(content)
            var sprnstr = "<!--startprint" + fang + "-->"
            var eprnstr = "<!--endprint" + fang + "-->"

            var iframe = document.createElement("IFRAME")
            // console.log('iframe')
            // console.log(iframe)
            var doc = null;
            iframe.setAttribute('style', 'position:absolute;width:0;height:0;left:-500px;top:-500px;')

            document.body.appendChild(iframe)
            doc = iframe.contentWindow.document
            doc.write(content)
            doc.close()
            iframe.contentWindow.focus()

            // iframe.contentWindow.addEventListener('click',function (event) {
            console.log('addEventListener')
            iframe.contentWindow.print()
            document.body.removeChild(iframe)
            // })

        },
        addOutStock() {
            if (this.form.customerId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择客户'
                })
                return
            }

            const ispList = []
            // console.log('addOutStock()')
            // console.log(this.outStockProdList)

            for (let i in this.outStockProdList) {

                if (this.outStockProdList[i].unitPrice == 0 || this.outStockProdList[i].unitPrice == null) {
                    this.$message({
                        type: 'info',
                        message: '请输入单价'
                    })
                    return
                }

                ispList.push({
                    productId: this.outStockProdList[i].productId,
                    quantity: this.outStockProdList[i].quantity,

                    unitPrice: this.outStockProdList[i].unitPrice,
                    amount: this.outStockProdList[i].amount,

                    remark: this.outStockProdList[i].productRemark
                })
            }

            this.$axios({
                method: "post",
                url: "/shiro/out/stock/add",
                data: {
                    id: this.form.id,
                    outStockCode: this.form.outStockCode,
                    customerId: this.form.customerId,

                    applicant: this.userId,
                    remark: this.form.remark,
                    outStockProductList: ispList,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false
                this.getAll(this.statusSearch)
            })

        },
        editClick() {

            this.productItemDisabled = false
            this.delBtnDisable = false

            this.saveBtnShow = true
        },
        searchByStatus(val) {

            this.getAll(val)
        },
        removeOutStock(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/out/stock/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAll(this.statusSearch)
            })
        },
        getAll(val) {
            this.loading = true

            // const formData = new FormData()

            // formData.append('status', val)
            // formData.append('queryParam', this.queryValue)

            // formData.append('companyId', this.companyId)
            // formData.append('pageIndex', -1)
            // formData.append('pageNum', -1)

            this.$axios({
                method: "post",
                url: "/shiro/out/stock/getAll",
                data: {
                    status: val,
                    queryParam: this.queryValue,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                this.form.id = ''
                this.total = 0

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.outStockList = data.data
                if (this.outStockList.length > 0) {
                    this.total = this.outStockList[0].total
                }
                for (let i in this.outStockList) {
                    this.outStockList[i].createdTime = this.$moment(this.outStockList[i].createdTime).format("YYYY-MM-DD")

                    if (this.outStockList[i].status == 0) {
                        this.outStockList[i].status = '待接收'
                    } else if (this.outStockList[i].status == 1) {
                        this.outStockList[i].status = '待审批'
                    } else if (this.outStockList[i].status == 2) {
                        this.outStockList[i].status = '已出库'
                    } else {
                        this.outStockList[i].status = '已退回'
                    }
                }
                this.loading = false
            })
        },
        pageClick(currentPage) {
            this.outStockList = []
            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll(this.statusSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val
            this.getAll(this.statusSearch)
        },
        digitUppercase(price) {

            const fraction = ['角', '分'];

            const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];

            const unit = [
                ['元', '万', '亿'],
                ['', '拾', '佰', '仟'],
            ];

            let num = Math.abs(price);

            let s = '';

            fraction.forEach((item, index) => {

                s += (digit[Math.floor(num * 10 * (10 ** index)) % 10] + item).replace(/零./, '');

            });

            //金额数字转大写代码

            s = s || '整';

            num = Math.floor(num);

            for (let i = 0; i < unit[0].length && num > 0; i += 1) {

                let p = '';

                for (let j = 0; j < unit[1].length && num > 0; j += 1) {

                    p = digit[num % 10] + unit[1][j] + p;

                    num = Math.floor(num / 10);

                }

                s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;

            }

            return s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
        }
    },
    mounted() {
        this.getAll(this.statusSearch)

        this.getBaseCustomerAll("")
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>